<template>
    <div class="server">
        <div class="content">
            <img src="@/static/hebei/public/server.png" alt="">
            <h3>系统升级中，即将开放</h3>
        </div>
    </div>
</template>

<script>
    export default {
        name: "server",
        created() {
            this.$emit("goRouter", "/server/");
        }
    }
</script>

<style scoped lang="less">
    .server{
        position: relative;
        width: 100%;
        height: 100vh;
        background: white;
        .content{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            text-align: center;
            h3{
                font-size: 18px;
                color:#00924C;
                margin-top: 20px;
            }
        }
    }
</style>
